import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import PIMRNView from './PumpSpareInternational/View';
import MRNMDView from './ManufacturingDomestic/View';

function MRNView() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [mrntype, setmrntype] = useState('');
  const [mrncategory, setmrncategory] = useState('');
  const [mrnData, setMrnData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}materialReceiptNote/findById/${id}`, {
          headers: authHeader(),
        });
        setMrnData(response.data);
        setmrntype(response.data.mrntype);
        setmrncategory(response.data.mrncategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (mrntype === 'Pump Spare' && mrncategory === 'International') {
      return <PIMRNView />;
    } else if (mrntype === 'Manufacturing') {
      return <MRNMDView />;
    }
    return null; // Default case
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}materialReceiptNote/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/mrnindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW GRN</h6>
          <div>
            <strong>Type:</strong> {mrntype} | <strong>Category:</strong> {mrncategory}
          </div>
          <div className="view-buttons">

            {mrncategory === "Domestic" && mrntype === "Manufacturing" && mrnData?.status === "Open" && (
              <Link to={`/grn-to-purchase-convert/${id}`}>
                <button className="button-70">Convert GRN To Purchase</button>
              </Link>
            )}

            {mrncategory === "International" && mrntype === "Pump Spare" && mrnData?.status === "Open" && (
              <Link to={`/grn-to-purchase-convert/${id}`}>
                <button className="button-70">Convert To Purchase</button>
              </Link>
            )}

            {mrnData?.status === "Open" && mrnData?.status !== "Cancelled" && (
              <Link to={`/mrnEdit/${id}/${pointindex}`}>
                <button className="button-70">EDIT</button>
              </Link>
            )}
            <Link to={`/mrnindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        {renderPageDisplay()}
      </Card>
    </div>
  );
}

export default MRNView;
